export function getImageUrl(media: Image = null, size: string = null): string | null {
    const imageSize = getImageSize(media, size);
    return imageSize !== null ? imageSize.url : null;
}

export default function getImageSize(media: Image = null, size: string = null): ImageSize | null {
    const { sizes = null } = media || {};
    const imageSize =
        size !== null
            ? (sizes || []).find(
                  ({ id }) => id === size || (id === 'large' && size === 'responsive'),
              ) || null
            : null;
    if (imageSize !== null) {
        return imageSize;
    }
    return media || null;
}
